var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { Injectable, filterObject } from "@banta/common";
import { FirebaseChatSource } from "./firebase-chat-source";
import { AuthenticationProvider, NotificationsProvider } from "@banta/common";
import { FirebaseStoreRef } from "./firebase-store-ref";
import { Subject, ReplaySubject } from "rxjs";
let FirebaseChatBackend = class FirebaseChatBackend {
    constructor(auth, notif, storeRef) {
        this.auth = auth;
        this.notif = notif;
        this.storeRef = storeRef;
        this._notificationsChanged = new ReplaySubject(1);
        this._newNotification = new Subject();
        this.datastore = this.storeRef.store;
        this._notificationsChanged.next(this.notif.current);
        this.notif.received.subscribe(notif => {
            this._newNotification.next(notif);
            this._notificationsChanged.next(this.notif.current);
        });
    }
    get notificationsChanged() {
        return this._notificationsChanged;
    }
    get newNotification() {
        return this._newNotification;
    }
    //private firestore : firebaseAdmin.firestore.Firestore;
    getSourceForTopic(topicId) {
        return __awaiter(this, void 0, void 0, function* () {
            return yield this.getSourceForCollection(topicId, `/bantaTopics/${topicId}`);
        });
    }
    getSourceForThread(topicId, id) {
        return __awaiter(this, void 0, void 0, function* () {
            return yield this.getSourceForCollection(topicId, `/bantaTopics/${topicId}/messages/${id}`);
        });
    }
    getSourceForCollection(identifier, collectionPath) {
        return __awaiter(this, void 0, void 0, function* () {
            return new FirebaseChatSource(identifier, this.auth, this.notif, collectionPath);
        });
    }
    refreshMessage(message) {
        return __awaiter(this, void 0, void 0, function* () {
            let result = yield this.datastore.read(`/bantaTopics/${message.topicId}/messages/${message.id}`);
            if (!result)
                return message;
            return result;
        });
    }
    getSubMessage(topicId, parentMessageId, messageId) {
        return __awaiter(this, void 0, void 0, function* () {
            return yield this.datastore.read(`/bantaTopics/${topicId}/messages/${parentMessageId}/messages/${messageId}`);
        });
    }
    getMessage(topicId, messageId) {
        return __awaiter(this, void 0, void 0, function* () {
            return yield this.datastore.read(`/bantaTopics/${topicId}/messages/${messageId}`);
        });
    }
    upvoteMessage(topicId, messageId, submessageId, vote) {
        return __awaiter(this, void 0, void 0, function* () {
            let message;
            if (submessageId)
                message = yield this.getSubMessage(topicId, messageId, submessageId);
            else
                message = yield this.getMessage(topicId, messageId);
            yield this.datastore.transact((txn) => __awaiter(this, void 0, void 0, function* () {
                let path = `/bantaTopics/${topicId}/messages/${messageId}`;
                if (submessageId) {
                    path = `/bantaTopics/${topicId}/messages/${messageId}/messages/${submessageId}`;
                }
                let existingVote = yield txn.read(`${path}/upvotes/${vote.id}`);
                if (existingVote) {
                    console.log(`Vote already exists`);
                    return;
                }
                yield Promise.all([
                    txn.set(`${path}/upvotes/${vote.id}`, vote),
                    txn.set(`${path}/counters/upvotes`, { value: this.datastore.sentinels.increment(1) }),
                    txn.update(`${path}`, { upvotes: this.datastore.sentinels.increment(1) })
                ]);
            }));
            if (vote.user) {
                yield this.notif.send({
                    recipientId: message.user.id,
                    type: 'upvote',
                    message,
                    user: vote.user
                });
            }
        });
    }
    watchMessage(message, handler) {
        if (!message || !message.id) {
            return;
        }
        let path = `/bantaTopics/${message.topicId}/messages/${message.id}`;
        if (message.parentMessageId)
            path = `/bantaTopics/${message.topicId}/messages/${message.parentMessageId}/messages/${message.id}`;
        let subscription = this.datastore.watch(path).subscribe(x => handler(x));
        return () => subscription.unsubscribe();
    }
    modifyMessage(message) {
        return __awaiter(this, void 0, void 0, function* () {
            let path;
            if (message.parentMessageId)
                path = `/bantaTopics/${message.topicId}/messages/${message.parentMessageId}/messages/${message.id}`;
            else
                path = `/bantaTopics/${message.topicId}/messages/${message.id}`;
            yield this.datastore.update(path, Object.assign(Object.assign({}, filterObject(message, [
                'message', 'hidden'
            ])), { updatedAt: Date.now() }));
        });
    }
};
FirebaseChatBackend = __decorate([
    Injectable(),
    __metadata("design:paramtypes", [AuthenticationProvider,
        NotificationsProvider,
        FirebaseStoreRef])
], FirebaseChatBackend);
export { FirebaseChatBackend };
//# sourceMappingURL=firebase-chat-backend.js.map